function Button({onClick, text}) {
  return (
    <div className="App">
      <div>{text}</div>
      <button className='button' onClick={onClick}>Click</button>
    </div>
  );
}

export default Button;
